export const typesetMathMl = element => {
  try {
    MathJax.Hub.Queue(['Typeset', MathJax.Hub, element])
  } catch (err) {
    // Retry in a little while in the hope that MathJax has loaded in the meantime
    setTimeout(() => typesetMathMl(element), 100)
  }
}
